// TranslationProvider.tsx
"use client";

import { ReactNode } from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "../../../i18n";
import { LanguageProvider } from "src/contexts/LanguageContext";

interface TranslationProviderProps {
  children: ReactNode;
}

const TranslationProvider = ({ children }: TranslationProviderProps) => {
  return (
    <LanguageProvider>
      <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
    </LanguageProvider>
  );
};

export default TranslationProvider;
